import helper from 'helpers/steinerHelper';

export const actionTypes = helper.createActionTypes('criteriQualitativi');
export const actions = helper.createActions('criteriQualitativi', actionTypes); 
